module.exports = __webpack_public_path__ + "img/supplier1.161eadfd.png";